import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';

export const useIsInvalidUser = (): boolean => {
  const user = useAppSelector(userSlice.selectUserInfo);
  if (user) {
    const hasUserRole = user.access?.userRoles?.some((role: string) =>
      /^tp\..+\.user$/.test(role),
    );
    return !hasUserRole;
  }
  return false;
};
